export class ErrorDialogComponentBase {
  public isErrorDialog: boolean;

  constructor(isErrorDialog: boolean) {
    this.isErrorDialog = isErrorDialog;
  }
}
